import { MSConstant } from '@/commons/wildcards';
import {getCurrentInstance} from 'vue';
/**
 * Xử lý control kỳ tính, từ ngày, đến ngày
 */
class SummaryUtil {
  /**
   * Thực hiện theo công thức được cấu hình tại cấu hình cột
   * @param {String} command: công thức
   * @param {String} field: cột
   * @param {Number} dataFormat: kiểu dữ liệu của cột
   * @author NVLAM 24.09.2020
   */
  doFunction(data, command, field, dataFormat, totalCount) {
    let me = this,
      result;
    switch (command) {
      case MSConstant.SummaryType.Sum:
        result = me.sumField(data, field, dataFormat);
        break;
      case MSConstant.SummaryType.SumAll:
        result = me.sumAllField(data, field, dataFormat);
        break;
      case MSConstant.SummaryType.Min:
        result = me.minField(data, field, dataFormat);
        break;
      case MSConstant.SummaryType.Max:
        result = me.maxField(data, field, dataFormat);
        break;
      case MSConstant.SummaryType.RowCount:
        result = me.rowCount(totalCount);
        break;
    }
    return result;
  }

  /**
   * Tính sum
   */
  sumField(data, field, dataFormat) {
    let me = this,
      sum = 0;
    data.forEach(item => {
      if (item[field]) {
        sum += parseFloat(item[field]); //.toFixed(FormatUtil.getDecimalDigitByFormatType(dataFormat))
      }
    });
    return sum;
  }

  /**
   * Tính max
   */
  maxField(data, field, dataFormat) {
    let me = this,
      res = null;
    data.forEach(item => {
      let value = item[field];
      if (res == null) {
        res = value;
      } else if (value > res) {
        res = value;
      }
    });
    return res;
  }

  /**
   * Tính min
   */
  minField(data, field, dataFormat) {
    let me = this,
      res = null;
    data.forEach(item => {
      let value = item[field];
      if (res == null) {
        res = value;
      } else if (value < res) {
        res = value;
      }
    });
    return res;
  }

  /**
   * Tính tổng tất cả các dữ liệu theo field
   * @param {String} field: cột
   * @param {Number} dataFormat: kiểu dữ liệu của cột
   * @author NVLAM 24.09.2020
   */
  sumAllField(data, field, dataFormat) {
    let sum = 0;
    if (data && data.length > 0) {
      data.forEach(item => {
        if (item[field]) {
          sum += parseFloat(item[field]); //.toFixed(FormatUtil.getDecimalDigitByFormatType(dataFormat))
        }
      });
      return sum;
    }
  }
/**
 * Parse dòng tổng ở footer
 * @param {*} data 
 * @returns 
 * NCPHUOC 26/04/2022
 */
  rowCount(data) {
    const { proxy } = getCurrentInstance();
    if (data) {
      let text = proxy.$t('i18nComponent.Grid.FooterRowCount', [
        data
      ]);
      return text;
    }
    return '';
  }
}
export default new SummaryUtil();
